<!--
 * @Descripttion:
 * @version: 0.0.1
 * @Author: ZHJI
 * @Date: 2019-09-25 09:23:56
 * @LastEditors: ZHJI
 * @LastEditTime: 2019-12-09 13:35:14
 -->
<!--  -->
<template>
  <basicContainer>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page="page"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @sort-change="sortChange"
      @on-load="onLoad"
      @refresh-change="refresh"
      @cell-click="cellClick"
    >
    <!-- 操作按钮扩展 -->
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"

          @click="handleDelete"
        >删 除</el-button>
      </template>
    <!-- 状态栏目扩展  -->
    <template v-slot:status="{row,label,dic,$index}" >
      <el-tag v-if="label === '正常'" type="success">{{label}}</el-tag>
      <el-tag v-else-if="label === '冻结'" type="info">{{label}}</el-tag>
       <el-tag v-else type="danger">{{label}}</el-tag>
    </template>
     <!-- 密码强度栏目扩展  -->
    <template v-slot:currentPasswordStrength="{row,label,dic,$index}" >
      <el-tag v-if="label === '非常弱'" type="danger">{{label}}</el-tag>
      <el-tag v-else-if="label === '弱'" type="warning">{{label}}</el-tag>
       <el-tag v-else-if="label === '一般'" type="info">{{label}}</el-tag>
        <el-tag v-else-if="label === '强'" type="success">{{label}}</el-tag>
       <el-tag v-else type="success">{{label}}</el-tag>
    </template>

    </avue-crud>

  </basicContainer>
</template>

<script>
import { optionConfig } from '@/framework/util/optionConfig'
export default {
  name: 'LoginStragy',
  data() {
    return {
      form: {},
      order: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      selectionList: [],
      option: {
        dialogWidth: 1000,
        dialogHeight: 400,
        height: 300,
        align: 'center',
        tip: true,
        stripe: true,
        border: true,
        index: true,
        viewBtn: true,
        selection: true,
        column: [
          {
            label: '策略名称',
            prop: 'name',
            search: true,
            rules: [{
              required: true,
              message: '请输入策略名称',
              trigger: 'blur'
            }]
          }, {
            label: '重试次数',
            prop: 'numberOfRetryLimit',
            sortable: true,
            type: 'number',
            controlsPosition: '',
            minRows: 0,
            maxRows: 100
          }, {
            label: '重置间隔',
            prop: 'resetFailureCountTime',
            sortable: true,
            type: 'input', rules: [
              { required: true, message: '请输入活动名称', trigger: 'blur' },
              { min: 1, type: 'number', message: '长度在 3 到 5 个字符', trigger: 'blur' }

            ]
          },
          {
            label: '状态',
            prop: 'status',
            sortable: true,
            type: 'select',
            slot: true,
            search: true,
            width: 120,
            dicData: [{
              label: '正常',
              value: 1
            }, {
              label: '停用',
              value: 2
            }],
            rules: [{
              required: true,
              message: '请选择状态',
              trigger: 'blur'
            }]
          }, {
            label: '备注',
            prop: 'remark',
            type: 'input'
          },
          {
            label: '处理类型',
            prop: 'handleType',
            type: 'select',
            slot: true,
            search: true,
            dicData: [{
              label: '验证码',
              value: 1
            }, {
              label: '冻结账号',
              value: 2
            }],
            rules: [{
              required: true,
              message: '请选择处理类型',
              trigger: 'blur'
            }]
          },
          {
            label: '冻结类型',
            prop: 'frozenType',
            type: 'select',
            slot: true,
            search: true,
            dicData: [{
              label: '冻结固定时长',
              value: 1
            }, {
              label: '定时解冻',
              value: 2
            }, {
              label: '永久冻结',
              value: 3
            }],
            rules: [{
              required: true,
              message: '请选择冻结类型',
              trigger: 'blur'
            }]
          }, {
            label: '冻结时间',
            prop: 'frozenTime',
            sortable: true,
            type: 'number',
            controlsPosition: '',
            minRows: 0,
            maxRows: 6000
          }
        ]
      },
      data: []

    }
  },

  components: { },

  mounted() {
    this.option = optionConfig(this.option)
  },
  methods: {
    cellClick: function(row, column, cell, event) {
      this.$refs.crud.toggleRowSelection(row)
    },
    refresh: function() {
      this.onLoad()
    },
    sortChange(value) {
      this.order.prop = value.prop
      this.order.order = value.order
      this.onLoad()
    },
    searchReset() {
      this.query = {}
      this.page.currentPage = 1
      this.onLoad()
    },
    searchChange(params, done) {
      done()
      this.query = params
      this.onLoad()
    },
    selectionChange(list) {
      this.selectionList = list
    },
    selectionClear() {
      this.selectionList = []
      this.$refs.crud.toggleSelection()
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize
    },
    rowSave(row, loading, done) {
      if (!row.userPassword || row.userPassword.length < 6) {
        return this.$message.warning('新增用户时,必须为用户填写密码,且密码长度需要大于 6 位。') && done()
      }
      let passScore = (row.userPassword)
      row.passwordStrength = passScore < 20 ? 1 : passScore < 40 ? 2 : passScore < 60 ? 3 : passScore < 80 ? 4 : 5
      this.$http.post('/account', [row])
        .then(response => {
          this.$message.success('添加用户成功') && loading()
          this.onLoad()
        }).catch(error => {
          this.$message.error(error.msg) && done()
        })
    },
    rowUpdate(row, index, loading, done) {
      if (row.userPassword && row.userPassword.length < 6) {
        return this.$message.warning('编辑用户时,如需要修改用户密码,密码长度需要大于 6 位。') && done()
      }
      this.$http.put('/account', [row])
        .then(response => {
          this.$message.success('编辑用户成功') && loading()
          this.onLoad()
        }).catch(error => {
          this.$message.error(error.msg) && done()
        })
    },
    rowDel(row, index) {
      this.deleteRows([row], () => {
        this.data.splice(index, 1)
      })
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        return this.$message.warning('请选择至少一条数据')
      }
      this.deleteRows(this.selectionList, () => {
        this.onLoad()
      })
    },
    deleteRows: function(deleteList, callback) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/account/delete', {}, { params: { accountIdList: deleteList.map(item => item.id) }}).then(
          response => {
            this.$message.success('删除成功') && typeof callback === 'function' && callback()
          }).catch(error => {
          this.$message.error(error.msg)
        })
      }).catch(e => {})
    },
    onLoad(page = this.page, params = this.query, order = this.order) {
      let orderItemList = []
      if (order.oder) {
        orderItemList.push({
          asc: order.oder === 'ascending',
          column: order.prop
        })
      }
      this.loading = true
      this.$http.post('/login-failure-strategy/query', { 'entity': params, orderItemList }, { params: {
        pageNum: page.currentPage,
        pageSize: page.pageSize
      }}).then(
        response => {
          this.loading = false
          this.data = response.data.records
          this.page.total = response.data.total || response.data.records.length
          this.selectionClear()
        }
      ).catch(
        error => {
          this.loading = false
          this.$message.error(error.msg)
        }
      )
    }
  }
}
</script>
<style lang='scss' scoped>
</style>
